import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.main.projects');
import { OnInit, ChangeDetectorRef as CDR, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-component-main-projects',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.main.projects/view.scss */
/* src/app/component.main.projects/view.scss: no such file or directory */`],
})
export class ComponentMainProjectsComponent implements OnInit {
    /** 선택된 프로젝트 목록 (부모에서 전달) */
    @Input() selectedProjects: any[] = [];

    /** 프로젝트 제거 완료 이벤트 (변경된 목록 전달) */
    @Output() onRemoved = new EventEmitter<any[]>();

    /** 프로젝트 상세 이동 이벤트 */
    @Output() onGoTo = new EventEmitter<any>();

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit() {
        // 페이지에서 init/렌더를 담당
    }
    
    /** 선택 목록에서 제거 - 직접 API 호출 */
    public async remove(project: any) {
        if (!confirm(`[${project.title}] 프로젝트를 점검 작업 목록에서 제거하시겠습니까?`)) {
            return;
        }

        const { code } = await wiz.call("unselect", { project_id: project.id });
        if (code === 200) {
            const newList = this.selectedProjects.filter(p => p.id !== project.id);
            this.onRemoved.emit(newList);
        }
    }
    
    /** 프로젝트 상세 페이지로 이동 */
    public goTo(project: any) {
        this.onGoTo.emit(project);
    }
}

export default ComponentMainProjectsComponent;